import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { fetchEstates } from "../services/api";
import EstateCard from "./EstateCard";

const Estates = () => {
  const [estates, setEstates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Skeleton loader component
  const EstateSkeleton = () => (
    <div className="col-xl-4 col-md-6">
      <div className="estate-card">
        <div className="estate-img">
          <Skeleton height={250} />
        </div>
        <div className="estate-content">
          <h4 className="estate-title">
            <Skeleton width={200} />
          </h4>
          <Skeleton count={2} />
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    const getEstates = async () => {
      setLoading(true);
      try {
        const response = await fetchEstates(0); // Always fetch first page
        if (response.success && response.payload) {
          // Take only the first 3 estates from the response
          setEstates(response.payload.page.slice(0, 3));
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    getEstates();
  }, []); // Removed currentPage dependency since we always want page 0

  return !loading && estates.length <= 0 ? (
    <></>
  ) : (
    <section className="estate-area">
      <div className="container">
        <div className="title-area text-center">
          <span className="sub-title">Our Estates</span>
          <h2 className="sec-title">Featured Estates</h2>
          <p>
            Over the years Sagama has been fully engaged in Estate Development
            and has developed the under listed Estate.
          </p>
        </div>
        <div className="row">
          {loading
            ? [...Array(3)].map((_, index) => <EstateSkeleton key={index} />)
            : estates.map((estate) => (
                <EstateCard key={estate.id} estate={estate} />
              ))}
        </div>
        <div className="text-center mt-4">
          <Link
            to="/estates"
            className="th-btn"
            style={{
              backgroundColor: "var(--theme-color)",
              color: "#fff",
              display: "inline-block",
              padding: "12px 24px",
              borderRadius: "4px",
              textDecoration: "none",
            }}
          >
            View All Estates <i className="fas fa-arrow-right ms-1" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Estates;
